import { useStoresContext } from 'contexts';
import { StoresContext } from 'contexts/types';

export const useStores = (): StoresContext => useStoresContext();
